export const payoutSmbFiberCsvMapping = (csvName, content) => {
  let csv = content
  ;({
    lineItem: () => {
      csv =
        content &&
        content.map(obj => {
          obj['Scheme Name'] = obj['schemeName'] ?? ''
          obj['Scheme Number'] = obj['schemeNumber'] ?? ''
          obj['Scheme type'] = obj['schemeType'] ?? ''
          obj['CAF Count'] = obj['cafCount'] ?? ''
          obj['CAF Number'] = obj['cafNumber'] ?? ''
          obj['Circle Name'] = obj['circleName'] ?? ''
          obj['MNP Flag'] = obj['mnpFlag'] ?? ''
          obj['ZD Name'] = obj['zdName'] ?? ''
          obj['Partner Role Name'] = obj['partnerRoleName'] ?? ''
          obj['Partner role type'] = obj['partnerRoleType'] ?? ''
          obj['ZD Id'] = obj['zdId'] ?? ''
          obj['Agent Code'] = obj['agentCode'] ?? ''
          obj['Price'] = obj['price'] ?? ''
          obj['R4J State Name'] = obj['r4jStateName'] ?? ''
          obj['Recharge'] = obj['recharge'] ?? ''
          obj['Activation Date'] = obj['activationDate'] ?? ''
          obj['From Date'] = obj['fromDate'] ?? ''
          obj['Quantity'] = obj['quantity'] ?? ''
          obj['ORN'] = obj['refId'] ?? ''
          obj['Termination Date'] = obj['terminationDate'] ?? ''
          obj['To Date'] = obj['toDate'] ?? ''
          obj['Material/Offer'] = obj['skuId'] ?? ''
          obj['Termination Flag'] = obj['terminationFlag'] ?? ''
          obj['Jio Center'] = obj['jioCenter'] ?? ''
          obj['City'] = obj['city'] ?? ''
          obj['CAF Date'] = obj['cafDate'] ?? ''
          obj['Prime'] = obj['prime'] ?? ''
          obj['Run Date'] = obj['runDate'] ?? ''
          obj['Hier Date'] = obj['hierarchyDate'] ?? ''
          delete obj['businessType']
          delete obj['loadingTime']
          delete obj['schemeName']
          delete obj['schemeNumber']
          delete obj['schemeType']
          delete obj['cafCount']
          delete obj['cafNumber']
          delete obj['circleName']
          delete obj['mnpFlag']
          delete obj['zdName']
          delete obj['partnerRoleName']
          delete obj['partnerRoleType']
          delete obj['zdId']
          delete obj['agentCode']
          delete obj['price']
          delete obj['r4jStateName']
          delete obj['recharge']
          delete obj['activationDate']
          delete obj['fromDate']
          delete obj['quantity']
          delete obj['refId']
          delete obj['terminationDate']
          delete obj['toDate']
          delete obj['skuId']
          delete obj['terminationFlag']
          delete obj['jioCenter']
          delete obj['city']
          delete obj['cafDate']
          delete obj['prime']
          delete obj['runDate']
          delete obj['hierarchyDate']
          return obj
        })
      return csv
    },
    header: () => {
      csv =
        content &&
        content.map(obj => {
          obj['Scheme Name'] = obj['schemeName'] ?? ''
          obj['Scheme Number'] = obj['schemeNumber'] ?? ''
          obj['Scheme type'] = obj['schemeType'] ?? ''
          obj['ZD Name'] = obj['zdName'] ?? ''
          obj['From Date'] = obj['fromDate'] ?? ''
          obj['To Date'] = obj['toDate'] ?? ''
          obj['ZD ID'] = obj['zdId'] ?? ''
          obj['ZD State Name'] = obj['zdStateName'] ?? ''
          obj['Region'] = obj['region'] ?? ''
          obj['Partner Role Name'] = obj['partnerRoleName'] ?? ''
          obj['Partner role type'] = obj['partnerRoleType'] ?? ''
          obj['Run Date'] = obj['runDate'] ?? ''
          obj['Hier Date'] = obj['hierarchyDate'] ?? ''
          obj['Commission'] = obj['commission'] ?? ''
          obj['Quantity'] = obj['quantity'] ?? ''
          obj['Circle Name'] = obj['circleName'] ?? ''
          obj['Clawback deduction'] = obj['clabackDeduction'] ?? ''
          obj['TDS deduction'] = obj['tdsDeduction'] ?? ''
          obj['Net payout'] = obj['netPayout'] ?? ''
          delete obj['businessType']
          delete obj['circleName']
          delete obj['clabackDeduction']
          delete obj['commission']
          delete obj['fromDate']
          delete obj['hierarchyDate']
          delete obj['loadingTime']
          delete obj['netPayout']
          delete obj['partnerRoleName']
          delete obj['partnerRoleType']
          delete obj['quantity']
          delete obj['region']
          delete obj['runDate']
          delete obj['schemeName']
          delete obj['schemeNumber']
          delete obj['schemeType']
          delete obj['tdsDeduction']
          delete obj['toDate']
          delete obj['zdId']
          delete obj['zdName']
          delete obj['zdStateName']
          return obj
        })
      return csv
    }
  }[csvName]())
  return csv
}
